import React from "react";
import styled from 'styled-components';

import {
	HeroParagraph,
	MainTitle
} from "../theme/typography";
import { Button } from "./Button";

import TressymBackgroundVertical from '../images/homepage/block-bgr-vertical-albumcover.webp';
import TressymBackgroundHorizontal from '../images/homepage/block-bgr-albumcover.webp';

const StyledTressymBlock = styled.div`
	box-sizing: border-box;
	background:
		linear-gradient(0deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.25) 95%),
		url(${TressymBackgroundVertical}) no-repeat center/cover;
	background-color: #212121;
	display: flex;
	flex-direction: column;
	padding: 1.5rem;
	position: relative;
	min-height: calc(100dvh - 3rem);
	text-align: center;

	@media screen and (orientation:landscape) {
		background: 
			linear-gradient(0deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.15) 100%),
			url(${TressymBackgroundHorizontal}) no-repeat center/cover;
	}

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.third}) {
		padding: 1.5rem 2rem 2rem;
	}

`;

const ContentContainer = styled.div`
	display: flex;
	flex: 1 0 100%;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
`;

const HeroLogo = styled(MainTitle)`
	font-size: 12vw;
	line-height: 12vw;
	margin-bottom: 0;

	@media screen and (orientation:landscape) {
		font-size: 7vw;
		line-height: 7vw;
	}
`;

const ContentTop = styled.div`
`;

const ContentBottom = styled.div`
	max-width: 34rem;
`;

const ButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 1.5rem;
`;

const LogoKicker = styled.h2`
	${(props) => props.theme.typography.headingXS};
	text-transform: uppercase;
	margin-top: 0.25rem;
	margin-bottom: 0;
	letter-spacing: 0.2px;

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.third}) {
		${(props) => props.theme.typography.headingM};
	}
`;

export class TressymBlock extends React.Component {

	render() {
		return (
			<StyledTressymBlock>
				<ContentContainer>
					<ContentTop>
						<HeroLogo>Tressym</HeroLogo>
						<LogoKicker>Tressym Drone Labs</LogoKicker>
					</ContentTop>
					<ContentBottom>
						<HeroParagraph>
							We are an enthusiastic community of drone racers. Our goal is to design the best racing drones in the world.
						</HeroParagraph>
						<HeroParagraph>
							All of our designs are open source.
						</HeroParagraph>
						<ButtonContainer>
							<Button 
									as="a"
									browse
									href={`https://tressym.myshopify.com`}
									label="Browse our store" 
								/>
							<Button
									as="a"
									discord
									href={`https://discord.gg/rRCda9KUWR`}
									label="Join us on Discord" 
								/>
						</ButtonContainer>
					</ContentBottom>
				</ContentContainer>
			</StyledTressymBlock>
		);
	}
}